export default __webpack_public_path__ + "static/media/saving_no_client.8faf34cd.png";